export const PLAN_ACTIVATION_DATA_LOCALSTORAGE_KEY = 'PlanActivationData';
